import Api from './api'

const path = '/plan'

const plan = {
  getAll(page = 1, perPage = 10) {
    return Api.request(`${path}?page=${page}&per_page=${perPage}`)
  },
  show(id) {
    return Api.request(`${path}/${id}`)
  },
  createOrUpdate(data) {
    if (data.id) {
      return Api.request(`${path}/${data.id}`, { data, method: 'PUT' })
    }
    return Api.request(path, { data, method: 'POST' })
  },
  deleteById(id) {
    return Api.request(`${path}/${id}`, { method: 'DELETE' })
  },
}

export default plan
